import "./text-scroll.component.css"
import React, { useLayoutEffect, useRef } from "react"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { Link, useNavigate } from "react-router-dom"
import { daggerNavigate } from "../../utils/navigate.util"

const TextScrollComponent = (props) => {
  const {
    id,
    Heading,
    Copy,
    ButtonLabel,
    PageLink,
    DisableScrollAnimation,
    Theme,
  } = props
  const elRef = useRef()
  const navigate = useNavigate()

  const handleInvertBackground = (invert) => {
    if (!elRef.current) {
      return
    }

    if (invert) {
      elRef.current.classList.add("inverted")
    } else {
      elRef.current.classList.remove("inverted")
    }
  }

  const theTheme = Theme ? `theme-${Theme.toLowerCase().replace("/", "-")}` : ""

  // Invert colors on scroll
  useLayoutEffect(() => {
    if (DisableScrollAnimation) return

    const trigger = ScrollTrigger.create({
      trigger: `.text-scroll-${id}`,
      start: "-160% top",
      onEnter: () => handleInvertBackground(true),
      onLeave: () => handleInvertBackground(false),
      onLeaveBack: () => handleInvertBackground(false),
      onEnterBack: () => handleInvertBackground(true),
    })

    return () => trigger.kill()
  }, [id, DisableScrollAnimation])

  const handlePageClick = (e) => {
    e.preventDefault()
    daggerNavigate(() => navigate(`/${PageLink.data.attributes.Slug}`))
  }

  return (
    <div
      className={`dagger-text-scroll text-scroll-${id} ${theTheme}`}
      ref={elRef}
    >
      <div className="dagger-text-scroll-content">
        <h2>{Heading}</h2>
        <div className="dagger-text-scroll-copy">
          <p>
            <>
              {Copy.split("|").map((part, i, arr) => (
                <React.Fragment key={i}>
                  {part}
                  {i < arr.length - 1 && (
                    <span className="dagger-line">&nbsp;</span>
                  )}
                </React.Fragment>
              ))}
            </>
          </p>
          {ButtonLabel && PageLink?.data && (
            <Link
              className="dagger-outline-btn"
              to={`/${PageLink.data.attributes.Slug}`}
              onClick={handlePageClick}
            >
              {ButtonLabel}
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export default TextScrollComponent
